import type { ComponentCreateDto, ComponentDto, ComponentUpdateDto, GetComponentsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  apiName = 'Inventory';

  create = (input: ComponentCreateDto) =>
    this.restService.request<any, ComponentDto>({
      method: 'POST',
      url: '/api/inventory/components',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/components/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ComponentDto>({
      method: 'GET',
      url: `/api/inventory/components/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetComponentsInput) =>
    this.restService.request<any, PagedResultDto<ComponentDto>>({
      method: 'GET',
      url: '/api/inventory/components',
      params: { filterText: input.filterText, name: input.name, description: input.description, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: ComponentUpdateDto) =>
    this.restService.request<any, ComponentDto>({
      method: 'PUT',
      url: `/api/inventory/components/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
